import { MAX_ORDER_ADMIN_SEARCH_LENGTH, type OrderAdminFilter } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Button, FilterSelect, SearchInput } from '@/shared/ui';

interface OrderFiltersProps {
  readonly filter: OrderAdminFilter;
  readonly search: string;
  readonly onFilter: (value: OrderAdminFilter) => void;
  readonly onSearch: (value: string) => void;
  readonly onSubmit: () => void;
  /** true 면 상태 알약 선택칸을 그리지 않는다(필터가 고정된 화면용). */
  readonly hideStatusFilter?: boolean;
}

const FILTERS = [
  ['TO_PROCESS', '처리할 건'],
  ['PENDING_PAYMENT', '결제 대기'],
  ['DELIVERED', '배송 완료'],
  ['REFUNDED', '환불 완료'],
  ['CANCELED', '주문 취소'],
  ['ALL', '전체'],
] as const;

/** 검색 대상 — 검색칸의 이름(라벨)이다. */
const SEARCH_LABEL = '주문 번호·견적 번호·회사·단체명·담당자명';

/**
 * 주문 목록 도구줄 — 상품 목록과 같은 알약 선택칸·돋보기 검색칸. 필터는 고르는 즉시, 검색어는 검색 버튼(또는 Enter)으로만
 * 적용한다 — 목록 조회마다 서버가 관리자 접속기록을 남기므로 입력마다 보내지 않는다.
 */
export const OrderFilters = ({
  filter,
  search,
  onFilter,
  onSearch,
  onSubmit,
  hideStatusFilter = false,
}: OrderFiltersProps): ReactElement => (
  <form
    aria-label="주문 검색"
    className="flex min-w-0 flex-1 flex-wrap items-center gap-2"
    onSubmit={(event) => {
      event.preventDefault();
      onSubmit();
    }}
  >
    {hideStatusFilter ? null : (
      <FilterSelect
        aria-label="필터"
        value={filter}
        onChange={(event) => {
          const value = FILTERS.find(([key]) => key === event.target.value)?.[0];
          if (value) onFilter(value);
        }}
      >
        {FILTERS.map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </FilterSelect>
    )}
    <SearchInput
      aria-label={SEARCH_LABEL}
      maxLength={MAX_ORDER_ADMIN_SEARCH_LENGTH}
      placeholder="주문·견적 번호, 회사, 담당자"
      value={search}
      onChange={(event) => onSearch(event.target.value)}
    />
    <Button type="submit" variant="outline" className="h-10 px-5">
      검색
    </Button>
  </form>
);
